import React, { useState } from "react";
import "./categories_tree.css"
import { useDispatch, useSelector } from "react-redux";
import { Modal, Form } from "react-bootstrap";
import { AppDispatch, RootState } from "../../../_store";
import { categoryAdd, categoriesList } from "../../../_store/thunks/category.thunk";
import AddButton from "../../../components/AddButton";
import SubmitButton from "../../../components/SubmitButton";
import { ICategory } from "../../../models/ICategory";

interface ICategoriesTreeProps {
    setErrorAlert: any;
    onSelectCategory: any;
}

export default function CategoriesTree(props: ICategoriesTreeProps) {

    const dispatch = useDispatch<AppDispatch>();

    const categories = useSelector((state: RootState) => state.category.categories);
    const [showAddCategoryModal, setShowAddCategoryModal] = useState<boolean>(false);

    const addCategory = (event: any) => {
        event.preventDefault();
        let name = event.target.name.value;
        let description = event.target.description.value;
        let parentId = Number(event.target.parentId.value);

        let request: ICategory = {
            id: 0,
            name: name,
            description: description
        }

        if (parentId !== 0) {
            request.parentId = parentId;
        }

        dispatch(categoryAdd(request)).then((x: any) => {
            if (x.error) {
                props.setErrorAlert(x.error.message);
            }
            else {
                setShowAddCategoryModal(false);
                dispatch(categoriesList());
            }
        })
    }


    return (<>
        <AddButton onClick={() => setShowAddCategoryModal(true)} size="sm"></AddButton>
        <hr></hr>
        <ul className="tree">
            {categories.filter(x => x.parentId === null).map((category: ICategory) => (
                <li key={category.id}>
                    <details>
                        <summary>
                            <button className="category"
                                onClick={() => props.onSelectCategory(category)}>{category.name}</button>
                        </summary>
                        <ul>
                            {categories.filter(x => x.parentId === category.id).map(sub => (
                                <li key={sub.id}>
                                    <button className="category"
                                        onClick={() => props.onSelectCategory(sub)}>{sub.name}</button>
                                </li>
                            ))}
                        </ul>
                    </details>
                </li>
            ))}
        </ul>

        <Modal show={showAddCategoryModal} onHide={() => setShowAddCategoryModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Добавить категорию</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={addCategory}>
                    <Form.Group className="mb-3">
                        <Form.Label>Родительская категория:</Form.Label>
                        <Form.Select id="parentId">
                            <option key={0} value={0}></option>
                            {categories?.map((main: ICategory) =>
                                (<option key={main.id} value={main.id}>{main.name}</option>))}
                        </Form.Select>
                        <Form.Text className="text-muted">
                            Если нужно создать главную категорию, то оставляйте поле пустым.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Название:</Form.Label>
                        <Form.Control type="text" />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="description">
                        <Form.Label>Описание:</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </Form.Group>

                    <SubmitButton />
                </Form>
            </Modal.Body>
        </Modal>

    </>);
}